import pdfTextEN from "../../locales/en-f280-pdf.json";
import pdfTextFR from "../../locales/fr-f280-pdf.json";

const getPDFTranslations = (lang = "en") => {
    let pdfText = lang === "en" ? pdfTextEN : pdfTextFR;

    const t = (fullKey, fallbackText = "", variables = {}) => {
        let key = fullKey.replace("f280pdf.", "");
        if (key in pdfText && pdfText[key] !== "nan"){
            let text = pdfText[key];
            for (let subKey in variables) {
                text = text.replace("{{" + subKey + "}}", variables[subKey]);
            }
            return text;
        }
        else
            return fallbackText !== "" ? fallbackText : key;
    }

    return { t };
}

export default getPDFTranslations;

